import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";

export class GetTayehMarketplaceStatsResponse {
    count_of_instances: string;
    total_sold: string;
    total_products: string;
    total_revenue: string;
}
export function getTyMarketplaceStats(): Promise<AxiosResponse<GetTayehMarketplaceStatsResponse>>{
    const query = `/marketplace/stats`;
    return Cirus.get(query);
}